const restaurant = {
  restaurant: "Restoranas", // translated 
  restaurants: "Restoranai", // translated 
  category: "Kategorija", // translated 
  score: "Rezultatas", // translated 
  priceQuartile: "Kainos kvartilis", // translated 
  scoreLowestFirst: "Balas (pirmas žemiausias)", // translated 
  scoreHighestFirst: "Rezultatas (pirmas aukščiausias)", // translated 
  priceLowestFirst: "Kaina (pirmiausia mažiausia)", // translated 
  priceHighestFirst: "Kaina (pirmiausia aukščiausia)", // translated 
  allPrices: "Visos kainos", // translated 
  reserve: "Rezervas", // translated 
  dining: "Pietauti", // translated 
};



export default restaurant;
